import {patchState, signalStore, withMethods, withState} from "@ngrx/signals";
import {DeviceInRange} from "src/app/domain/devices/device-in-range";

interface DeviceInRangeState {
  devicesInRange: Map<string, DeviceInRange>;
}

const initialState: DeviceInRangeState = {
  devicesInRange: new Map()
};

export const DeviceInRangeStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => ({
    reset() {
      patchState(store, { devicesInRange: new Map() })
    },
    addDevice(id: string, rssi: number) {
      const devicesInRange = new Map(store.devicesInRange());
      devicesInRange.set(id, { id, rssi });
      patchState(store, { devicesInRange });
    }
  })
));
